import { CIDS } from '@webrcade/app-common';

import { AnalogAdjustment, AnalogModeDetector, BaseMapping } from './base';

export class GalacticStormMapping extends BaseMapping {
  getName() {
    return 'galastrm';
  }

  getButtonMap() {
    const { emuInput } = this;
    return {
      ...emuInput.BUTTONMAP_BASE,
      [CIDS.A]: emuInput.INP_B1,
      [CIDS.B]: emuInput.INP_B2,
      [CIDS.X]: emuInput.INP_B3,
      [CIDS.Y]: emuInput.INP_B4,
      [CIDS.LBUMP]: emuInput.INP_B3,
      [CIDS.RBUMP]: emuInput.INP_B1,
      [CIDS.LTRIG]: emuInput.INP_B3,
      [CIDS.RTRIG]: emuInput.INP_B1,
    };
  }

  getAnalogAdjustments() {
    return [
      new AnalogAdjustment(0, true, 2),
      new AnalogAdjustment(0, false, 2),
    ];
  }

  getAnalogModeDetectors() {
    const { emuInput } = this;
    return [
      new AnalogModeDetector(
        0,
        'P1 Stick X',
        'slider 0x4000 0x4001 speed 0x800 center 10',
        emuInput.INP_LEFT | emuInput.INP_RIGHT,
        'joyaxis 0 0',
        0,
        true,
      ),
      new AnalogModeDetector(
        0,
        'P1 Stick Y',
        'slider 0x4002 0x4003 speed 0x800 center 10',
        emuInput.INP_UP | emuInput.INP_DOWN,
        'joyaxis 0 1',
        0,
        false,
      ),
    ];
  }

  // getRemapList() {
  //   return [
  //     ["P2 Gun X", "joyaxis 1 0"],
  //     ["P2 Gun Y", "joyaxis 1 1"],
  //     ['P1 Fire 1', 'switch 0x4080'],
  //     ['P1 Fire 2', 'switch 0x4081'],
  //     ['P1 Fire 3', 'switch 0x4082']
  //   ];
  // }

  isAnalogDpadEnabled() {
    return false;
  }
}

// 0: (2) ['Coin 1', 'switch 0x06']
// 1: (2) ['Coin 2', 'switch 0x07']
// 2: (2) ['P1 Start', 'switch 0x02']
// 3: (2) ['P1 Button 1', 'switch 0x4080']
// 4: (2) ['P1 Button 2', 'switch 0x4081']
// 5: (2) ['P1 Button 3', 'switch 0x4082']
// 6: (2) ['P1 Button 4', 'switch 0x4083']
// 7: (2) ['P1 Stick X', 'slider 0x4000 0x4001 speed 0x800 center 10']
// 8: (2) ['P1 Stick Y', 'slider 0x4002 0x4003 speed 0x800 center 10']
// 9: (2) ['Reset', 'switch 0x3D']
// 10: (2) ['Service', 'switch 0x0A']
// 11: (2) ['Service Mode', 'switch 0x3C']
